



























































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({
  components: {}
})
export default class SocialLinks extends Vue {
  $refs!: {
    wrapper: HTMLElement;
  };
}
